import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CommonUiCommonRenderingsModule } from '@legacy/common-ui-common-renderings';

import { FunctionalErrorContainerComponent } from './functional-error-container/functional-error-container.component';
import { FunctionalErrorItemPipe } from './functional-errors.pipe';

//TODO: move the FunctionalErrorComp to this folder

@NgModule({
  imports: [
    CommonModule,
    CommonUiCommonRenderingsModule,
    FunctionalErrorItemPipe,
    FunctionalErrorContainerComponent,
  ],
  exports: [FunctionalErrorItemPipe, FunctionalErrorContainerComponent],
})
export class FunctionalErrorsModule {}
